module.exports = __webpack_public_path__ + "static/media/industrial-bg.17de0664.jpg";